import { Mui } from '@osu/react-ui';
import { useEffect, useRef, useState } from 'react';
import {
    useGetSystemWideMessagesQuery,
    useDismissSystemWideMessagesMutation,
} from '../../services/graphql/api';
import useRoleAuthentication from "../../Common/hooks/useRoleAuthentication";

function SystemWideMessageChecker() {
    const authDetails = useRoleAuthentication();
    const [dismissed, setDismissed] = useState(false);

    const skipQuery = !authDetails.CURRENT_EMPLID;
    const {
        data: systemWideMessagesData,
        refetch,
    } = useGetSystemWideMessagesQuery(undefined, {
        skip: skipQuery,
        pollingInterval: 60 * 10 * 1000, // 10min
    });

    const [dismissMessages] = useDismissSystemWideMessagesMutation();

    const messages = systemWideMessagesData?.messages ?? [];
    const messageIds = systemWideMessagesData?.messageIds ?? [];
    const hasMessages = messages.length > 0 && !dismissed;

    async function dismissSystemWideMessage(event) {
        event.stopPropagation();
        if (messageIds.length > 0) {
            dismissMessages(messageIds);
        }
        setDismissed(true);
    }

    // Reset dismissed state when new messages arrive
    useEffect(() => {
        if (messages.length > 0) {
            setDismissed(false);
        }
    }, [messages.length]);

    const oneMessagePerLine = { display: "block" };

    return (
        <Mui.Snackbar open={hasMessages} TransitionComponent={Mui.Slide} anchorOrigin={{ vertical: 'top', horizontal: 'center', }}>
            <Mui.Alert onClose={dismissSystemWideMessage} severity="warning" style={{}}>
                {messages.map?.(message => (<span style={oneMessagePerLine}>{message}</span>))}
            </Mui.Alert>
        </Mui.Snackbar>
    );
}

export default SystemWideMessageChecker;
